import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import MultiSelect from './components/MultiSelect';

export default class DialogStaticMultiSelect extends React.Component {
    render() {
        const { field, value, onChange } = this.props;
        const mappedItems = field?.items.map((str) => ({
            id: str,
            label: str
        }));

        return (
            <MultiSelect
                id={field.id}
                label={i18n.t(`columns.${field.label}`)}
                placeholder={i18n.t(`placeholder.${field.label}`)}
                items={mappedItems}
                value={value}
                onChange={(newVal) => onChange(field.id, newVal)}
            />
        );
    }
}

DialogStaticMultiSelect.propTypes = {
    field: PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
    }).isRequired,
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    value: PropTypes.array,
    onChange: PropTypes.func.isRequired
};

DialogStaticMultiSelect.defaultProps = {
    value: []
};
